<script setup lang="ts">
  import ButtonQC from '@qicgroupdoha/qic-connect-ds/components/ButtonQC'
  import { useLinkTarget } from '@/shared/composables/useLinkTarget'
  import { computed, inject } from 'vue'

  interface Props {
    name: string
    logo: string
    background: string
    link: string
  }

  defineProps<Props>()

  const { getLinkTarget } = useLinkTarget()

  const localeRTL = inject<boolean>('localeRTL')
  const buttonIcon = computed(() => (localeRTL ? 'arrow-narrow-left' : 'arrow-narrow-right'))
</script>

<template>
  <div class="travel-kit-card" :style="{ background }">
    <div class="travel-kit-card__logo">
      <img :src="logo" alt="" />
    </div>
    <div class="travel-kit-card__content">
      <div class="travel-kit-card__text">
        <h4 class="travel-kit-card__title heading-4">
          <slot name="title" />
        </h4>
        <p class="travel-kit-card__description text-regular">
          <slot name="description" />
        </p>
      </div>

      <div>
        <ButtonQC
          variant="outline"
          size="medium"
          :href="link"
          :target="getLinkTarget()"
          :icon-after-content="buttonIcon"
          :data-test="`travel-kit-${name}-link`"
          class="travel-kit-card__link"
        >
          <slot name="cta" />
        </ButtonQC>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  .travel-kit-card {
    position: relative;
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: 52px var(--spacing-2) var(--spacing-2);
    border-radius: var(--radius-8);
    box-shadow: var(--spacing-0) var(--spacing-2) var(--spacing-3) var(--spacing-0)
      var(--colorAlphaBlack4);

    &__logo {
      position: absolute;
      top: 14px;
      inset-inline-start: 24px;
    }

    &__content {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      height: 100%;
      gap: var(--spacing-7);
      padding: var(--spacing-6);
      border-radius: 28px;
      background: rgba(255, 255, 255, 0.95);
    }

    &__text {
      display: flex;
      flex-direction: column;
      gap: var(--spacing-2);
    }

    &__title {
      color: var(--colorTxtSrfContrastDark);
    }

    &__description {
      color: var(--colorTxtSrfContrastDark);
    }
  }
</style>

<style lang="scss">
  .travel-kit-card {
    &__link {
      white-space: nowrap;
    }
  }
</style>
